// The shopping list as text, for "Copy list".
//
// This exists because the list has to be usable somewhere we are not. Nothing
// in this release sends the list to a store — see PickupSection — so the user
// carries it themselves: into the retailer's own site, a notes app, or a
// message to whoever is actually going. Copying is the transfer mechanism, and
// it is an honest one.
//
// The same rules the screen follows apply here, because a copied list that
// disagrees with the screen is worse than no copy button:
//
//   - Only what the user intends to buy. An excluded ingredient is a
//     purchasing decision, and the copy is purchasing.
//   - An amount we never had is *said*, not silently dropped and not guessed.
//     "coriander — amount not given" is a line the user can act on in the
//     aisle; "coriander" alone quietly loses the fact that we didn't know.
//   - A row with no name is not an item. The user added it and never filled it
//     in, so there is nothing to buy.

// `name — quantity` rather than `quantity name`, because quantities in a real
// recipe are not all numbers. "salt — to taste" reads correctly; "to taste
// salt" does not, and "to taste" is an amount we deliberately accept as one.
export function formatIngredientLine(item) {
  const name = String(item?.name ?? '').trim();
  if (!name) return null;
  const quantity = String(item?.quantity ?? '').trim();
  return quantity ? `- ${name} — ${quantity}` : `- ${name} — amount not given`;
}

export function formatShoppingList(items, { dishName, servings } = {}) {
  const lines = (items ?? [])
    .filter((item) => item?.included !== false)
    .map(formatIngredientLine)
    .filter(Boolean);

  // Nothing to buy is not a list. The button that calls this is disabled in
  // that case; returning empty rather than a lonely heading means a stray call
  // cannot put a title and no items on someone's clipboard.
  if (lines.length === 0) return '';

  const heading = dishName
    ? servings
      ? `${dishName} — ${servings} servings`
      : dishName
    : null;

  return [heading, heading ? '' : null, ...lines].filter((line) => line !== null).join('\n');
}

export function shoppingListCount(items) {
  return (items ?? []).filter((item) => item?.included !== false && String(item?.name ?? '').trim()).length;
}
